import { Component } from '@angular/core';
import { ListTenantComponent } from '../employees/list-tenant/list-tenant';

@Component({
  selector: 'app-admin-tenants',
  standalone: true,
  imports: [ListTenantComponent],
  templateUrl: './tenants-view.html'
})
export class AdminTenantsView {}
